// extracted by mini-css-extract-plugin
var _1 = "SubMenuList-moduleSubMenuList__NPg8o";
export { _1 as "SubMenuList" }
